import { makeAutoObservable, runInAction } from 'mobx';
import { FetchPatientsParams, Patient, PatientsFilters } from 'types';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import { API_PROFILE_V1_PATIENTS, API_PROFILE_V1_PATIENTS_EXCEL } from 'consts';
import { AxiosMethod, LoadingStatus, PaginationDirection } from 'enums';
import {
  createLinkElementForBlob,
  removeEmptyArraysFromObj,
  removeUndefinedFromObj,
} from 'utils/functions';

class ExportPatientsStore {
  patients: Patient[] = [];

  hasNext: boolean = false;

  hasPrevious: boolean = false;

  filters: PatientsFilters = {};

  status: LoadingStatus = LoadingStatus.IDLE;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchPatients(params?: FetchPatientsParams) {
    this.patients = [];
    this.status = LoadingStatus.PENDING;
    const { items, hasNext, hasPrevious } =
      await NetworkRequestHandler.sendRequest({
        url: API_PROFILE_V1_PATIENTS,
        method: AxiosMethod.POST,
        data: {
          page: {
            anchorEntity: null,
            fetchDirection: PaginationDirection.FORWARD,
            ...params?.page,
            size: 10,
            sortDirection: 'ASC',
          },
          filters: removeEmptyArraysFromObj(
            removeUndefinedFromObj(params?.filters as object),
          ),
        },
      });
    runInAction(() => {
      this.patients = items;
      this.hasNext = hasNext;
      this.hasPrevious = hasPrevious;
      this.status = LoadingStatus.DONE;
    });
  }

  async fetchPatientsExcel() {
    const file = await NetworkRequestHandler.sendRequest({
      url: API_PROFILE_V1_PATIENTS_EXCEL,
      method: AxiosMethod.POST,
      data: {
        filters: removeEmptyArraysFromObj(removeUndefinedFromObj(this.filters)),
        sort: {
          sortDirection: 'ASC',
        },
      },
      responseType: 'blob',
    });
    createLinkElementForBlob(file, 'exportPatientsExcel');
  }

  setFilter(filterParams: PatientsFilters) {
    this.filters = { ...this.filters, ...filterParams };
  }

  cleanFilter() {
    this.filters = {};
  }
}

export default new ExportPatientsStore();
